module.exports = __webpack_public_path__ + "img/02.7f25ffbf.png";